import { Link } from 'react-router-dom'
import classes from './ChatWidget.module.scss'
import { formatChatMoney } from './chatFormatters'
import { getServiceStatusTone, ServiceStatusTone } from './serviceProductStatus'
import { ChatServiceProduct } from './types'

/** Servis/iade takip sayfası; kartın tek çıkış kapısı. */
const SERVICE_TRACKING_PATH = '/myspecial/myReturns'

const BADGE_TONE_CLASS: Record<ServiceStatusTone, string> = {
  done: classes.orderBadgeInvoiced,
  waiting: classes.serviceBadgeWaiting,
  neutral: classes.orderBadgePending,
}

/** Kur 5 ondalığa kadar basılır. `formatChatRate` burada kullanılmaz — o yüzde işareti ekliyor. */
function formatExchangeRate(rate: number) {
  return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 5 }).format(rate)
}

interface Props {
  items: ChatServiceProduct[]
}

/**
 * Servisteki ürünler (arıza takip) kartı. Veri seyrek geldiği için etiket/değer ızgarası değil
 * kompakt liste: boş alanın satırı hiç çizilmez, satır sayısı kayıttan kayda değişir.
 */
export default function ServiceProductsCard({ items }: Props) {
  if (items.length === 0) return null

  return (
    <section className={classes.serviceCard}>
      <div className={classes.serviceCardTitle}>Servisteki Ürünleriniz ({items.length})</div>

      {items.map((item, index) => {
        const meta = [
          item.serialNumber ? `seri ${item.serialNumber}` : '',
          item.formNumber ? `form ${item.formNumber}` : '',
        ].filter(Boolean)
        const price = item.unitPrice
        const rate = item.exchangeRate
        const rateText = typeof rate === 'number' && rate !== 1 ? ` · Kur ${formatExchangeRate(rate)}` : ''

        return (
          <div key={`${item.formNumber || 'row'}-${index}`} className={classes.serviceRow}>
            <div className={classes.serviceRowHead}>
              <span className={classes.serviceProductName}>{item.productName}</span>
              {item.status && (
                <span
                  className={`${classes.orderBadge} ${classes.serviceBadge} ${
                    BADGE_TONE_CLASS[getServiceStatusTone(item.status)]
                  }`}
                >
                  {item.status}
                </span>
              )}
            </div>

            {meta.length > 0 && <div className={classes.serviceMeta}>{meta.join(' · ')}</div>}

            {typeof price === 'number' && (
              <div className={classes.serviceMoney}>
                B.F. {formatChatMoney(price, item.currency ?? 'TRY')}
                {rateText}
              </div>
            )}
          </div>
        )
      })}

      <Link className={classes.serviceFooterLink} to={SERVICE_TRACKING_PATH} target='_blank' rel='noopener noreferrer'>
        Servis / İade takip →
      </Link>
    </section>
  )
}
